import { render } from "./qjjj.vue?vue&type=template&id=ed310890"
import script from "./qjjj.vue?vue&type=script&lang=js"
export * from "./qjjj.vue?vue&type=script&lang=js"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__